<!--
  Decisão de 27/08/2026: o shell (header/sidenav/footer) saiu daqui — antes
  ficava condicionado globalmente a `isLogged$`, agora vive só dentro de
  `/{tenant}/cliente/**` (ver modules/home/shell/shell.component.ts), mais
  correto porque não depende de sincronizar manualmente com o guard de rota.
  A tela de login (`/{tenant}/`) já era renderizada sem shell, sem mudança
  de comportamento ali.
-->
<router-outlet></router-outlet>

<app-loader></app-loader>
